import React, { useCallback, useState } from "react";
import { Typography } from "@material-ui/core";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import { DialogDelete, DialogImage } from "./DialogPopups";
import { deleteClientJournalImages, deleteClientProfileImage } from "./AzureStorage.service";
import { deleteClientProfileData, deleteJournalData } from "./googledrivefunc";
import { BrowserView, MobileView } from 'react-device-detect';

export default function ImageThumb({
    files,
    multi,
    maxFiles,
    journalId,
    getRootProps,
    getInputProps,
    handleEmptyFile,
    handleChangeImage,
    handleFileChange,
    fileInputRef,
    handleDivClick,
    dragging,
    openCapture
}) {
    const [deleteFile, setDeleteFile] = useState({});
    const [imageFile, setImageFile] = useState("");

    const handleClose = () => {
        return setDeleteFile({});
    };

    const handleDelete = useCallback(async () => {
        const newUpdatedFiles = files.filter(file => file.imageName !== deleteFile.imageName).filter(file => file.isGoogleImage);
        const deleteFn = multi
            ? (deleteFile.isGoogleImage ? deleteJournalData(deleteFile, newUpdatedFiles, journalId) : deleteClientJournalImages(deleteFile.therapistId, deleteFile.clientId, [deleteFile.imageName]))
            : (deleteFile.isGoogleImage ? deleteClientProfileData(deleteFile) : deleteClientProfileImage(deleteFile.therapistId, deleteFile.clientId, deleteFile.imageName))

        const res = await deleteFn;

        if (res) {
            await handleEmptyFile(deleteFile);
        }
        if (multi) {
            handleClose()
        }
    }, [deleteFile, handleEmptyFile, multi]);

    // Uploaded Image as Thumb for display
    const thumbs = files.map(file => {
        if (!file.imageUrl) {
            return <div className="thumb" key={file.imageName}>
                <div className="upload_image_drag_select_multi" style={{ cursor: "auto" }}>
                    <p className="not_found_google_image">To view image login with your google drive previous loggedIn</p>
                </div>
            </div>
        }
        return (
            <div className="thumb" key={file.imageName}>
                <div className="thumb_inner">
                    <img
                        src={file.imageUrl}
                        className="thumb_img"
                        style={{ cursor: 'pointer' }}
                        alt={"img"}
                        onClick={() => {
                            setImageFile(file.imageUrl);
                        }}
                    />
                    <div className="thumb_inner_buttons">
                        <EditRoundedIcon className="thumb_button" onClick={() => handleChangeImage(file)} />
                        <DeleteRoundedIcon
                            className="thumb_button"
                            onClick={() => {
                                setDeleteFile(file);
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    });
    return (
        <>
            <div className="thumbs_container">
                {thumbs}
                {multi && files.length < maxFiles && (
                    <div style={{ display: "flex", alignItems: "center", height: "200px", }}>
                        <label>
                            <div
                                {...getRootProps()}
                                className="upload_image_drag_select_multi"
                                style={{
                                    border: dragging && "1px dashed blue",
                                    alignItems: "center"
                                }}>
                                <input {...getInputProps()}
                                    onClick={(event) => {
                                        event.target.value = null
                                    }}
                                />
                                <img src="images/docIcon.svg" alt="success" height={40} width={40} />
                                <Typography variant="subtitle1" style={{ marginTop: "10px", fontWeight: "500" }}>
                                    Tilføj billede
                                </Typography>
                            </div>
                        </label>
                        {/* divider like or */}
                        <Typography
                            variant="subtitle1"
                            align="center"
                            style={{ margin: "10px", opacity: 0.6, fontWeight: "500" }}>
                            Eller
                        </Typography>
                        {/* Camera Access for upload Image */}
                        <BrowserView>
                            <div className="upload_image_drag_select_multi" onClick={() => openCapture()} style={{ width: "150px", height: "200px", cursor: 'pointer' }}>
                                <img src="images/cameraIcon.svg" alt="success" height={40} width={34} />
                                <Typography variant="subtitle1" style={{ marginTop: "10px", fontWeight: "500" }}>
                                    Tag et billede
                                </Typography>
                            </div>
                        </BrowserView>
                        <MobileView>
                            <div className="upload_image_drag_select_multi" onClick={handleDivClick} style={{ width: "150px", height: "200px", cursor: 'pointer' }}>
                                <img src="images/cameraIcon.svg" alt="success" height={40} width={34} />
                                <Typography variant="subtitle1" style={{ marginTop: "10px", fontWeight: "500" }}>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        capture="filesystem"
                                        hidden
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                    />
                                    Tag et billede
                                </Typography>
                            </div>
                        </MobileView>
                    </div>
                )}
            </div>

            {/* Popup Delete - DialogBox */}
            {Object.keys(deleteFile).length > 0 && (
                <DialogDelete handleDelete={handleDelete} deleteFile={deleteFile} handleClose={handleClose} />
            )}

            {/* Popup Image - DialogBox */}
            {Object.keys(imageFile).length > 0 && <DialogImage imageFile={imageFile} handleClose={() => setImageFile("")} />}
        </>
    );
}
